const electionName = completeFindPollingStation => {
    return completeFindPollingStation ? completeFindPollingStation.election.name : '';
};

const electionDay = completeFindPollingStation => {
    return completeFindPollingStation
        ? new Date(completeFindPollingStation.election.electionDay).toDateString()
        : '';
};

const pollingStationNotes = completeFindPollingStation => {
    return completeFindPollingStation
        ? completeFindPollingStation.pollingStation.notes
            ? completeFindPollingStation.pollingStation.notes
            : ''
        : '';
};

const pollingStationHours = completeFindPollingStation => {
    return completeFindPollingStation
        ? completeFindPollingStation.pollingStation.pollingHours
            ? completeFindPollingStation.pollingStation.pollingHours
            : ''
        : '';
};

const pollingStationAddress = completeFindPollingStation => {
    return completeFindPollingStation
        ? completeFindPollingStation.pollingStation.address
        : '';
};

export const ConfirmationInfoFullAddress = completeFindPollingStation => {
    return completeFindPollingStation
        ? pollingStationAddress(completeFindPollingStation)
            ? `${completeFindPollingStation.pollingStation.address.streetNo} ${
                  completeFindPollingStation.pollingStation.address.street
              }, ${completeFindPollingStation.pollingStation.address.city}, ${
                  completeFindPollingStation.pollingStation.address.state
              } ${completeFindPollingStation.pollingStation.address.zipCode}`
            : ''
        : '';
};

export const ConfirmationInfoTitle = completeFindPollingStation => {
    return completeFindPollingStation
        ? electionName(completeFindPollingStation)
            ? pollingStationAddress(completeFindPollingStation)
                ? `We found your polling station so you can vote in ${electionName(
                      completeFindPollingStation
                  )}.`
                : `Unfortunately, your polling station for ${electionName(
                      completeFindPollingStation
                  )} is not available yet.`
            : 'Unfortunately, your polling station and election information are not available yet.'
        : '';
};

export const ConfirmationInfoOtherDetails = completeFindPollingStation => {
    return completeFindPollingStation
        ? electionName(completeFindPollingStation)
            ? pollingStationAddress(completeFindPollingStation)
                ? `On ${electionDay(
                      completeFindPollingStation
                  )} head to ${ConfirmationInfoFullAddress(
                      completeFindPollingStation
                  )} to make your voice heard.` +
                  ' ' +
                  pollingStationNotes(completeFindPollingStation) +
                  ' ' +
                  pollingStationHours(completeFindPollingStation)
                : `Check back closer to ${electionDay(
                      completeFindPollingStation
                  )} to find your polling station and make your voice heard.`
            : 'Check back closer to Election Day to see if the information has become available.'
        : '';
};



// WEBPACK FOOTER //
// ./src/components/FindPollingStation/ConfirmationInfo.jsx